// actions/deliveryActions.js
import {
    FETCH_DELIVERIES_REQUEST,
    FETCH_DELIVERIES_SUCCESS,
    FETCH_DELIVERIES_FAILURE,
    UPDATE_DELIVERY_STATUS_REQUEST,
    UPDATE_DELIVERY_STATUS_SUCCESS,
    UPDATE_DELIVERY_STATUS_FAILURE,
  } from './types';
  import { fetchDeliveries } from "../../services/deliveryService"; 
  import { updateDeliveryStatus } from '../../services/deliveryService';
  
  // Action Creators
  export const fetchDeliveriesRequest = () => ({ type: FETCH_DELIVERIES_REQUEST });
  export const fetchDeliveriesSuccess = (deliveriesData) => ({
    type: FETCH_DELIVERIES_SUCCESS,
    payload: deliveriesData,
  });
  export const fetchDeliveriesFailure = (error) => ({
    type: FETCH_DELIVERIES_FAILURE,
    payload: error,
  });

  // Action Creators for updating delivery status
export const updateDeliveryStatusRequest = () => ({ type: UPDATE_DELIVERY_STATUS_REQUEST });
export const updateDeliveryStatusSuccess = (updatedDelivery) => ({
  type: UPDATE_DELIVERY_STATUS_SUCCESS,
  payload: updatedDelivery,
});
export const updateDeliveryStatusFailure = (error) => ({
  type: UPDATE_DELIVERY_STATUS_FAILURE,
  payload: error,
});
  
  // Thunk to fetch deliveries
  export const fetchDeliveriesAction = (filterField, filterValue, page = 1, size = 50) => async (dispatch) => {
    dispatch(fetchDeliveriesRequest());
  
    try {
      const response = await fetchDeliveries(filterField, filterValue, page, size);
  
      if (response.error) {
        dispatch(fetchDeliveriesFailure(response.error));
        return { success: false, error: response.error };
      } else {
        dispatch(fetchDeliveriesSuccess(response));

        return { success: true, data: response };
      }
    } catch (error) {
      dispatch(fetchDeliveriesFailure(error.message || "Failed to fetch deliveries"));
      return { success: false, error: error.message || "Failed to fetch deliveries" };
    }
  };
  
  // Thunk to update delivery status
export const updateDeliveryStatusAction = (deliveryId, newStatus) => async (dispatch) => {
  dispatch(updateDeliveryStatusRequest());

  try {
    const response = await updateDeliveryStatus(deliveryId, newStatus);

    if (response.error) {
      dispatch(updateDeliveryStatusFailure(response.error));
      return { success: false, error: response.error };
    } else {
      dispatch(updateDeliveryStatusSuccess(response));
      return { success: true, data: response };
    }
  } catch (error) {
    dispatch(updateDeliveryStatusFailure(error.message || "Failed to update delivery status"));
    return { success: false, error: error.message || "Failed to update delivery status" };
  }
};